import React, { FunctionComponent } from 'react';
import { format } from 'date-fns';

import {
  PriceOutOfDate,
  PriceOutOfDateContent,
  PriceOutOfDateText,
  PriceOutOfDateWrapper,
  StyledUpdatePriceButton,
  Title,
  Wrapper,
} from './BillInfo.style';
import { PackagePrice } from '../PackagePrice';
import { PriceDetails } from '../PriceDetails';
import { BestPriceTooltip } from '../BestPriceTooltip';
import { RefreshClock } from '@lt/components/icons-react';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

type Props = {
  /** цена с включенными сборами*/
  currentPrice: number;
  /** цена за вычетом сборов */
  netPrice: number;
  oldPrice?: number;
  instantConfirm: boolean;
  discount: boolean;
  priceOutOfDate?: boolean;
  isLoadingActualize?: boolean;
  onActualize?: () => void;
  lastPriceUpdateDate?: Date | string;
  className?: string;
  parentWidth?: number;
};

const dateFormat = (updateDate: Props['lastPriceUpdateDate']) => {
  if (!updateDate) {
    return '';
  }

  const date = typeof updateDate === 'string' ? new Date(updateDate) : updateDate;

  return format(date, 'HH:mm, dd.MM.yy');
};
export const BillInfo: FunctionComponent<Props> = ({
  priceOutOfDate,
  currentPrice,
  netPrice,
  oldPrice,
  discount,
  isLoadingActualize,
  onActualize,
  lastPriceUpdateDate,
  className,
  instantConfirm,
  parentWidth,
}) => {
  const additionalFees = currentPrice - netPrice;
  return (
    <Wrapper className={className}>
      <Title>
        Гарантия лучшей цены
        <BestPriceTooltip />
      </Title>

      <PackagePrice
        instantConfirm={instantConfirm}
        currentPrice={currentPrice}
        oldPrice={oldPrice}
        discount={discount}
      />
      <PriceDetails additionalFees={additionalFees} netPrice={netPrice} />
      {priceOutOfDate && (
        <PriceOutOfDateWrapper parentWidth={parentWidth}>
          <PriceOutOfDateContent parentWidth={parentWidth}>
            <StyledUpdatePriceButton
              type="button"
              variant="default"
              disabled={isLoadingActualize}
              onClick={onActualize}
              size="tiny"
            >
              {parentWidth &&
              parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minSm &&
              parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd
                ? 'Обновить'
                : 'Обновить цену'}
            </StyledUpdatePriceButton>
            <PriceOutOfDate>
              <RefreshClock width={16} />
              <PriceOutOfDateText>
                Цена актуальна <br />
                на {dateFormat(lastPriceUpdateDate)}
              </PriceOutOfDateText>
            </PriceOutOfDate>
          </PriceOutOfDateContent>
        </PriceOutOfDateWrapper>
      )}
    </Wrapper>
  );
};
